module.exports = __webpack_public_path__ + "static/media/step2.001a1397.png";